import React from 'react'
import SEO from '../components/SEO'
import Layout from '../components/Layout'
import Howitworks from '../components/LearnComps/Howitworks'
import Receiveoffers from '../components/LearnComps/Receiveoffers'
import Propinfo from '../components/LearnComps/Propinfo'

import Collab from '../components/LearnComps/Collab'
import Activity from '../components/LearnComps/Activity'
import Val1 from '../components/LearnComps/Val1'
import Val2 from '../components/LearnComps/Val2'
import Val3 from '../components/LearnComps/Val3'
import Val4 from '../components/LearnComps/Val4'
import Val5 from '../components/LearnComps/Val5'
import Signupnow2 from '../components/CTAsections/Signupnow2'
import Valstatement from '../components/LearnComps/Valstatement'

const Privacy = () => {
  return (
    <>
      <Layout>
        <SEO
          title="How It Works (HLM) HomeLight Listing Management | Cooperating Real Estate Agents use (HLM) HomeLight Listing Management to get to offer accepted, faster!"
          meta={[
            {name: `title`, content: 'How It Works | Cooperating Real Estate Agents use Disclosures.io to get to offer accepted, faster!'},
            {
              name: `description`,
              content:
                'One software for cooperating agents. Securely share property information, monitor buyer interest and compare offers in one place. Simple, effective, and trusted by Top Real Estate Agents everywhere. ',
            },
            {
              property: `og:image`,
              content: 'https://disclosures-cdn.s3-us-west-2.amazonaws.com/assets/Marketing/hlm-mktg-site/HLM+Social+Final+1.png',
            },
            {property: 'og:image:width', content: '600'},
            {property: 'og:image:height', content: '315'},
            {property: `og:title`, content: 'Disclosures.io'},
            {property: 'og:url', content: 'https://disclosures.io'},
            {
              property: `og:description`,
              content:
                'One software for cooperating agents. Securely share property information, monitor buyer interest and compare offers in one place. Simple, effective, and trusted by Top Real Estate Agents everywhere.',
            },
            {property: 'og:site_name', content: '(HLM) HomeLight Listing Management'},
            {property: `og:type`, content: `website`},
            {name: `twitter:card`, content: `summary_large_image`},
            {name: `twitter:site`, content: `@Disclosuresio`},
            {name: `twitter:creator`, content: '@Disclosuresio'},
            {name: `twitter:title`, content: "Disclosures.io | On-market to offer accepted, faster! - Sign Up Now! (It's free!)"},
            {
              name: `twitter:description`,
              content:
                'One software for cooperating agents. Securely share property information, monitor buyer interest and compare offers in one place. Simple, effective, and trusted by Top Real Estate Agents everywhere. ',
            },
            {
              name: 'keywords',
              content:
                '(HLM) HomeLight Listing Management, Disclosures.io, Disclosures.io pricing, Disclosures.io reviews, Disclosures.io How it works, Disclosures.io BBB, real estate broker tools, real estate listing management, disclosure package, property package, real estate disclosure, realtor crm, nhd report, property disclosure, real estate transaction management, realtor tools, tc tools, real estate crm, real estate software, buyers agent, home disclosure, listing agent,',
            },
          ]}
        />

        <Howitworks />

        <Val2 />
        <Propinfo />

        <Val3 />
        <Activity />
        <Val4 />
        <Receiveoffers />

        <Val1 />
        <Collab />
        <Val5 />
        <Signupnow2 />
      </Layout>
    </>
  )
}

export default Privacy
